module.exports = __webpack_public_path__ + "static/media/login-error-amber.ee104051.svg";